"use strict";
/**
 * Copyright 2018 Google LLC
 *
 * Distributed under MIT license.
 * See file LICENSE for detail or copy at https://opensource.org/licenses/MIT
 */

var _createClass = require("C:\\Users\\vince\\repositories\\SKS-2019\\node_modules\\@babel\\runtime/helpers/createClass");

var _classCallCheck = require("C:\\Users\\vince\\repositories\\SKS-2019\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("C:\\Users\\vince\\repositories\\SKS-2019\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Users\\vince\\repositories\\SKS-2019\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Users\\vince\\repositories\\SKS-2019\\node_modules\\@babel\\runtime/helpers/inherits");

var _wrapNativeSuper = require("C:\\Users\\vince\\repositories\\SKS-2019\\node_modules\\@babel\\runtime/helpers/wrapNativeSuper");

var _regeneratorRuntime = require("C:\\Users\\vince\\repositories\\SKS-2019\\node_modules\\@babel\\runtime/regenerator");

var _asyncToGenerator = require("C:\\Users\\vince\\repositories\\SKS-2019\\node_modules\\@babel\\runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GoogleToken = void 0;

var fs = require("fs");

var gaxios_1 = require("gaxios");

var jws = require("jws");

var path = require("path");

var util_1 = require("util");

var readFile = fs.readFile ? util_1.promisify(fs.readFile) :
/*#__PURE__*/
_asyncToGenerator(
/*#__PURE__*/
_regeneratorRuntime.mark(function _callee() {
  return _regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          throw new ErrorWithCode('use key rather than keyFile.', 'MISSING_CREDENTIALS');

        case 1:
        case "end":
          return _context.stop();
      }
    }
  }, _callee);
}));
var GOOGLE_TOKEN_URL = 'https://www.googleapis.com/oauth2/v4/token';
var GOOGLE_REVOKE_TOKEN_URL = 'https://accounts.google.com/o/oauth2/revoke?token=';

var ErrorWithCode =
/*#__PURE__*/
function (_Error) {
  _inherits(ErrorWithCode, _Error);

  function ErrorWithCode(message, code) {
    var _this;

    _classCallCheck(this, ErrorWithCode);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ErrorWithCode).call(this, message));
    _this.code = code;
    return _this;
  }

  return ErrorWithCode;
}(_wrapNativeSuper(Error));

var getPem;

var GoogleToken =
/*#__PURE__*/
function () {
  /**
   * Create a GoogleToken.
   *
   * @param options  Configuration object.
   */
  function GoogleToken(options) {
    _classCallCheck(this, GoogleToken);

    this.configure(options);
  }

  _createClass(GoogleToken, [{
    key: "hasExpired",

    /**
     * Returns whether the token has expired.
     *
     * @return true if the token has expired, false otherwise.
     */
    value: function hasExpired() {
      var now = new Date().getTime();

      if (this.rawToken && this.expiresAt) {
        return now >= this.expiresAt;
      } else {
        return true;
      }
    }
    /**
     * Returns whether the token will expire within eagerRefreshThresholdMillis
     *
     * @return true if the token will be expired within eagerRefreshThresholdMillis, false otherwise.
     */

  }, {
    key: "isTokenExpiring",
    value: function isTokenExpiring() {
      var _a;

      var now = new Date().getTime();
      var eagerRefreshThresholdMillis = (_a = this.eagerRefreshThresholdMillis) !== null && _a !== void 0 ? _a : 0;

      if (this.rawToken && this.expiresAt) {
        return this.expiresAt <= now + eagerRefreshThresholdMillis;
      } else {
        return true;
      }
    }
  }, {
    key: "getToken",
    value: function getToken(callback) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (typeof callback === 'object') {
        opts = callback;
        callback = undefined;
      }

      opts = Object.assign({
        forceRefresh: false
      }, opts);

      if (callback) {
        var cb = callback;
        this.getTokenAsync(opts).then(function (t) {
          return cb(null, t);
        }, callback);
        return;
      }

      return this.getTokenAsync(opts);
    }
    /**
     * Given a keyFile, extract the key and client email if available
     * @param keyFile Path to a json, pem, or p12 file that contains the key.
     * @returns an object with privateKey and clientEmail properties
     */

  }, {
    key: "getCredentials",
    value: function () {
      var _getCredentials = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(keyFile) {
        var ext, key, body, privateKey, clientEmail, _privateKey, _privateKey2;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                ext = path.extname(keyFile);
                _context2.t0 = ext;
                _context2.next = _context2.t0 === '.json' ? 4 : _context2.t0 === '.der' ? 13 : _context2.t0 === '.crt' ? 13 : _context2.t0 === '.pem' ? 13 : _context2.t0 === '.p12' ? 17 : _context2.t0 === '.pfx' ? 17 : 25;
                break;

              case 4:
                _context2.next = 6;
                return readFile(keyFile, 'utf8');

              case 6:
                key = _context2.sent;
                body = JSON.parse(key);
                privateKey = body.private_key;
                clientEmail = body.client_email;

                if (!(!privateKey || !clientEmail)) {
                  _context2.next = 12;
                  break;
                }

                throw new ErrorWithCode('private_key and client_email are required.', 'MISSING_CREDENTIALS');

              case 12:
                return _context2.abrupt("return", {
                  privateKey: privateKey,
                  clientEmail: clientEmail
                });

              case 13:
                _context2.next = 15;
                return readFile(keyFile, 'utf8');

              case 15:
                _privateKey = _context2.sent;
                return _context2.abrupt("return", {
                  privateKey: _privateKey
                });

              case 17:
                if (getPem) {
                  _context2.next = 21;
                  break;
                }

                _context2.next = 20;
                return Promise.resolve().then(function () {
                  return require('google-p12-pem');
                });

              case 20:
                getPem = _context2.sent.getPem;

              case 21:
                _context2.next = 23;
                return getPem(keyFile);

              case 23:
                _privateKey2 = _context2.sent;
                return _context2.abrupt("return", {
                  privateKey: _privateKey2
                });

              case 25:
                throw new ErrorWithCode('Unknown certificate type. Type is determined based on file extension. ' + 'Current supported extensions are *.json, *.pem, and *.p12.', 'UNKNOWN_CERTIFICATE_TYPE');

              case 26:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function getCredentials(_x) {
        return _getCredentials.apply(this, arguments);
      }

      return getCredentials;
    }()
  }, {
    key: "getTokenAsync",
    value: function () {
      var _getTokenAsync = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(opts) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(this.inFlightRequest && !opts.forceRefresh)) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return", this.inFlightRequest);

              case 2:
                _context3.prev = 2;
                _context3.next = 5;
                return this.inFlightRequest = this.getTokenAsyncInner(opts);

              case 5:
                return _context3.abrupt("return", _context3.sent);

              case 6:
                _context3.prev = 6;
                this.inFlightRequest = undefined;
                return _context3.finish(6);

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[2,, 6, 9]]);
      }));

      function getTokenAsync(_x2) {
        return _getTokenAsync.apply(this, arguments);
      }

      return getTokenAsync;
    }()
  }, {
    key: "getTokenAsyncInner",
    value: function () {
      var _getTokenAsyncInner = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(opts) {
        var creds;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(this.isTokenExpiring() === false && opts.forceRefresh === false)) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return", Promise.resolve(this.rawToken));

              case 2:
                if (!(!this.key && !this.keyFile)) {
                  _context4.next = 4;
                  break;
                }

                throw new Error('No key or keyFile set.');

              case 4:
                if (!(!this.key && this.keyFile)) {
                  _context4.next = 11;
                  break;
                }

                _context4.next = 7;
                return this.getCredentials(this.keyFile);

              case 7:
                creds = _context4.sent;
                this.key = creds.privateKey;
                this.iss = creds.clientEmail || this.iss;

                if (!creds.clientEmail) {
                  this.ensureEmail();
                }

              case 11:
                return _context4.abrupt("return", this.requestToken());

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getTokenAsyncInner(_x3) {
        return _getTokenAsyncInner.apply(this, arguments);
      }

      return getTokenAsyncInner;
    }()
  }, {
    key: "ensureEmail",
    value: function ensureEmail() {
      if (!this.iss) {
        throw new ErrorWithCode('email is required.', 'MISSING_CREDENTIALS');
      }
    }
  }, {
    key: "revokeToken",
    value: function revokeToken(callback) {
      if (callback) {
        this.revokeTokenAsync().then(function () {
          return callback();
        }, callback);
        return;
      }

      return this.revokeTokenAsync();
    }
  }, {
    key: "revokeTokenAsync",
    value: function () {
      var _revokeTokenAsync = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        var url;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (this.accessToken) {
                  _context5.next = 2;
                  break;
                }

                throw new Error('No token to revoke.');

              case 2:
                url = GOOGLE_REVOKE_TOKEN_URL + this.accessToken;
                _context5.next = 5;
                return gaxios_1.request({
                  url: url
                });

              case 5:
                this.configure({
                  email: this.iss,
                  sub: this.sub,
                  key: this.key,
                  keyFile: this.keyFile,
                  scope: this.scope,
                  additionalClaims: this.additionalClaims
                });

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function revokeTokenAsync() {
        return _revokeTokenAsync.apply(this, arguments);
      }

      return revokeTokenAsync;
    }()
    /**
     * Configure the GoogleToken for re-use.
     * @param  {object} options Configuration object.
     */

  }, {
    key: "configure",
    value: function configure() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.keyFile = options.keyFile;
      this.key = options.key;
      this.rawToken = undefined;
      this.iss = options.email || options.iss;
      this.sub = options.sub;
      this.additionalClaims = options.additionalClaims;

      if (typeof options.scope === 'object') {
        this.scope = options.scope.join(' ');
      } else {
        this.scope = options.scope;
      }

      this.eagerRefreshThresholdMillis = options.eagerRefreshThresholdMillis;
    }
    /**
     * Request the token from Google.
     */

  }, {
    key: "requestToken",
    value: function () {
      var _requestToken = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6() {
        var iat, additionalClaims, payload, signedJWT, r, body, desc;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                iat = Math.floor(new Date().getTime() / 1000);
                additionalClaims = this.additionalClaims || {};
                payload = Object.assign({
                  iss: this.iss,
                  scope: this.scope,
                  aud: GOOGLE_TOKEN_URL,
                  exp: iat + 3600,
                  iat: iat,
                  sub: this.sub
                }, additionalClaims);
                signedJWT = jws.sign({
                  header: {
                    alg: 'RS256'
                  },
                  payload: payload,
                  secret: this.key
                });
                _context6.prev = 4;
                _context6.next = 7;
                return gaxios_1.request({
                  method: 'POST',
                  url: GOOGLE_TOKEN_URL,
                  data: {
                    grant_type: 'urn:ietf:params:oauth:grant-type:jwt-bearer',
                    assertion: signedJWT
                  },
                  headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                  },
                  responseType: 'json'
                });

              case 7:
                r = _context6.sent;
                this.rawToken = r.data;
                this.expiresAt = r.data.expires_in === null || r.data.expires_in === undefined ? undefined : (iat + r.data.expires_in) * 1000;
                return _context6.abrupt("return", this.rawToken);

              case 13:
                _context6.prev = 13;
                _context6.t0 = _context6["catch"](4);
                this.rawToken = undefined;
                this.tokenExpires = undefined;
                body = _context6.t0.response && _context6.t0.response.data ? _context6.t0.response.data : {};

                if (body.error) {
                  desc = body.error_description ? ": ".concat(body.error_description) : '';
                  _context6.t0.message = "".concat(body.error).concat(desc);
                }

                throw _context6.t0;

              case 20:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[4, 13]]);
      }));

      function requestToken() {
        return _requestToken.apply(this, arguments);
      }

      return requestToken;
    }()
  }, {
    key: "accessToken",
    get: function get() {
      return this.rawToken ? this.rawToken.access_token : undefined;
    }
  }, {
    key: "idToken",
    get: function get() {
      return this.rawToken ? this.rawToken.id_token : undefined;
    }
  }, {
    key: "tokenType",
    get: function get() {
      return this.rawToken ? this.rawToken.token_type : undefined;
    }
  }, {
    key: "refreshToken",
    get: function get() {
      return this.rawToken ? this.rawToken.refresh_token : undefined;
    }
  }]);

  return GoogleToken;
}();

exports.GoogleToken = GoogleToken;